import { TemplateRef } from "@angular/core";
import { GridColumn } from "@veritas-shared/models/grid-column";

export class gpsDetailsColumn {
  public gps = (
    template: TemplateRef<any>
  ): GridColumn => ({
    field: 'gps',
    title: 'GPS CALOTTA', // TODO add translations
    resizable: false,
    sortable: false,
    template,
  });

  public sitGis = (
    template: TemplateRef<any>
  ) => ({
    field: 'sitGis',
    title: 'SIT-GIS', // TODO add translations
    resizable: false,
    sortable: false,
    template,
  })
}